import { render } from "./CreateAccessTokenModal.vue?vue&type=template&id=18c5445d"
import script from "./CreateAccessTokenModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAccessTokenModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/CreateAccessTokenModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18c5445d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18c5445d', __exports__)) {
    api.reload('18c5445d', __exports__)
  }
  
  module.hot.accept("./CreateAccessTokenModal.vue?vue&type=template&id=18c5445d", () => {
    api.rerender('18c5445d', render)
  })

}


export default __exports__